import type { Paragraph } from '@/api/types/stowed-element'
import {
  DEFAULT_ALIGNMENT,
  DEFAULT_FONT_FAMILY_ID,
  DEFAULT_FONT_ID,
  DEFAULT_POINT_SIZE,
} from '@/lib/text/constants/text-defaults'

/**
 * The single empty paragraph a brand-new Type-tool drag frame starts with: the book/checkpoint
 * default font and size (then the hardcoded defaults), plus the last-used TypePanel
 * kerning/tracking/underline/alignment. Font and size never follow the TypePanel, so restyling
 * one frame leaves new frames on the default.
 */
export function buildTextFrameInitialParagraphs({
  newTextBoxAlignment,
  defaultFontSize,
  resolvedDefaultFontId,
  resolvedDefaultFontFamilyId,
  newTextBoxKerning,
  newTextBoxTracking,
  newTextBoxUnderline,
}: {
  newTextBoxAlignment: number | undefined
  defaultFontSize: number | undefined
  resolvedDefaultFontId: number | undefined
  resolvedDefaultFontFamilyId: number | undefined
  newTextBoxKerning: number | undefined
  newTextBoxTracking: number | undefined
  newTextBoxUnderline: boolean | undefined
}): Paragraph[] {
  return [
    {
      alignment: newTextBoxAlignment ?? DEFAULT_ALIGNMENT,
      textLines: [
        {
          textRuns: [
            {
              pointSize: defaultFontSize ?? DEFAULT_POINT_SIZE,
              fontId: resolvedDefaultFontId ?? DEFAULT_FONT_ID,
              fontFamilyId: resolvedDefaultFontFamilyId ?? DEFAULT_FONT_FAMILY_ID,
              // Leading always starts at Metric for new text — never inherits another
              // frame's last-used value (unlike kerning/tracking/underline below).
              ...(newTextBoxKerning !== undefined ? { kerning: newTextBoxKerning } : {}),
              ...(newTextBoxTracking !== undefined ? { tracking: newTextBoxTracking } : {}),
              ...(newTextBoxUnderline !== undefined ? { underline: newTextBoxUnderline } : {}),
              textContent: '',
            },
          ],
        },
      ],
    },
  ]
}
